const defaultInputsCheckout = {
  name: 'Default Template',
  author: 'Superfin',
  urlImage: '',
  version: '1.0.0',
  settings: {
    theme: [],
    inputs: [
      {
        id: 1,
        identifier: 'input',
        element: 'input',
        labelName: 'Nome Completo',
        name: 'name',
        visibility: true,
        width: [12, 12, 7, 7],
        settings: false,
        options: false,
        field: {
          type: 'text',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o seu nome',
          required: true,
          InputLabelProps: { shrink: false },
          fullWidth: true,
        },
      },
      {
        id: 2,
        element: 'input',
        name: 'birthDate',
        labelName: 'Nascimento',
        visibility: true,
        width: [12, 12, 5, 5],
        settings: false,
        options: false,
        field: {
          type: 'date',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'digite o seu nome',
          required: true,
          InputLabelProps: { shrink: false },
          fullWidth: true,
          InputProps: {
            inputProps: {
              min: `${new Date(Date.now()).getFullYear() - 100}-01-01`,
              max: `${new Date(Date.now()).getFullYear() - 18}-${(
                new Date(Date.now()).getMonth() + 1
              )
                .toString()
                .padStart(2, '0')}-${new Date(Date.now())
                .getDate()
                .toString()
                .padStart(2, '0')}`,
            },
          },
        },
      },
      {
        id: 3,
        element: 'input',
        name: 'email',
        labelName: 'E-mail',
        visibility: true,
        width: [12, 12, 7, 6],
        settings: false,
        options: false,
        field: {
          type: 'email',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o seu e-mail',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
      {
        id: 4,
        element: 'input',
        name: 'document',
        labelName: 'CPF/CNPJ',
        visibility: true,
        width: [12, 12, 5, 6],
        settings: false,
        options: false,
        field: {
          type: 'text',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o seu CPF/CNPJ',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
      {
        id: 5,
        element: 'input',
        name: 'address.postalCode',
        labelName: 'CEP',
        visibility: true,
        width: [12, 12, 8, 8],
        settings: false,
        options: false,
        field: {
          type: 'text',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o seu CEP',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
      {
        id: 6,
        element: 'select',
        name: 'address.state',
        labelName: 'Estado',
        visibility: true,
        width: [12, 12, 4, 4],
        settings: false,
        options: [
          'AC',
          'AL',
          'AP',
          'AM',
          'BA',
          'CE',
          'DF',
          'ES',
          'GO',
          'MA',
          'MT',
          'MS',
          'MG',
          'PA',
          'PB',
          'PR',
          'PE',
          'PI',
          'RJ',
          'RN',
          'RS',
          'RO',
          'RR',
          'SC',
          'SP',
          'SE',
          'TO',
        ],
        field: {
          type: 'select',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'digite o seu nome',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
      {
        id: 7,
        element: 'input',
        name: 'address.city',
        labelName: 'Cidade',
        visibility: true,
        width: [12, 12, 6, 6],
        settings: false,
        options: false,
        field: {
          type: 'text',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o nome da sua cidade',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
      {
        id: 8,
        element: 'input',
        name: 'address.neighborhood',
        labelName: 'Endereço',
        visibility: true,
        width: [12, 12, 6, 6],
        settings: false,
        options: false,
        field: {
          type: 'text',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o seu endereço',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
      {
        id: 9,
        element: 'input',
        name: 'address.street',
        labelName: 'Rua',
        visibility: true,
        width: [12, 12, 8, 8],
        settings: false,
        options: false,
        field: {
          type: 'text',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite a sua rua',
          InputLabelProps: { shrink: false },
          fullWidth: true,
        },
      },
      {
        id: 10,
        element: 'input',
        name: 'address.number',
        labelName: 'Número',
        visibility: true,
        required: true,
        width: [12, 12, 4, 4],
        settings: false,
        options: false,
        field: {
          type: 'number',
          size: 'small',
          color: 'primary',
          variant: 'outlined',
          placeholder: 'Digite o seu número',
          InputLabelProps: { shrink: false },
          required: true,
          fullWidth: true,
        },
      },
    ],
  },
}

export default defaultInputsCheckout
